"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _selectInputModule = _interopRequireDefault(require("./selectInput.module.css"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _arrowRightIcon = _interopRequireDefault(require("../icons/arrowRightIcon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectInput = function SelectInput(props) {
  var id = props.id,
      options = props.options,
      onChange = props.onChange,
      value = props.value,
      name = props.name,
      disabled = props.disabled,
      required = props.required,
      onBlur = props.onBlur,
      isLoading = props.isLoading,
      autoComplete = props.autoComplete,
      groupedOptions = props.groupedOptions;
  return _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)(_themeModule.default.arag, _selectInputModule.default["buttonPickerWrapper"])
  }, _react.default.createElement("select", {
    id: id ? "".concat(id, "_select") : null,
    autoComplete: autoComplete ? autoComplete : "",
    className: (0, _classnames.default)(_themeModule.default.arag, _selectInputModule.default["form-control-custom"]),
    value: value || '',
    name: name,
    onChange: onChange,
    disabled: disabled,
    required: required,
    onBlur: onBlur
  }, groupedOptions ? groupedOptions.map(function (group) {
    return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("option", {
      disabled: true,
      className: _selectInputModule.default["option-group"]
    }, "".concat(group.label, "  (").concat(group.options.length, ")")), group.options.map(function (option) {
      return _react.default.createElement("option", {
        id: id ? "".concat(id, "_option_").concat(option.key) : null,
        value: option.key,
        key: option.key,
        disabled: option.disabled
      }, option.label);
    }));
  }) : options.map(function (option) {
    return _react.default.createElement("option", {
      id: id ? "".concat(id, "_option_").concat(option.key) : null,
      value: option.key,
      key: option.key,
      disabled: option.disabled
    }, option.label);
  })), isLoading && _react.default.createElement("div", {
    id: id ? "".concat(id, "_loader_wrapper") : null,
    className: _selectInputModule.default["loader"]
  }, _react.default.createElement("span", {
    id: id ? "".concat(id, "_dot_1") : null,
    className: (0, _classnames.default)(_selectInputModule.default["loader-dot"], _selectInputModule.default["loader-dot-1"])
  }), _react.default.createElement("span", {
    id: id ? "".concat(id, "_dot_2") : null,
    className: (0, _classnames.default)(_selectInputModule.default["loader-dot"], _selectInputModule.default["loader-dot-2"])
  }), _react.default.createElement("span", {
    id: id ? "".concat(id, "_dot_3") : null,
    className: (0, _classnames.default)(_selectInputModule.default["loader-dot"], _selectInputModule.default["loader-dot-3"])
  })), _react.default.createElement("button", {
    id: id ? "".concat(id, "_select_button") : null,
    className: (0, _classnames.default)(_selectInputModule.default["btn"], _selectInputModule.default["form-control"], _selectInputModule.default["buttonPicker"]),
    tabIndex: -1
  }, _react.default.createElement(_arrowRightIcon.default, {
    id: id ? "".concat(id, "_select_button_icon") : null,
    className: _selectInputModule.default["icon-arrow"]
  })));
};

SelectInput.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** String text that enables or disable the browser to offer autocompletion */
  autoComplete: _propTypes.default.string,

  /** Callback invoked on blur. An event argument will be available. eg: (evt) => {} */
  onBlur: _propTypes.default.func,

  /** Callback invoked on option select. An event argument will be available. eg: (evt) => {} */
  onChange: _propTypes.default.func,

  /** The selected option key */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** The name attribute of the input */
  name: _propTypes.default.string.isRequired,

  /** Boolean indicating if the input is disabled */
  disabled: _propTypes.default.bool,

  /** Boolean indicating if the element is required */
  required: _propTypes.default.bool,

  /** The select input options */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
    disabled: _propTypes.default.bool
  })),
  groupedOptions: _propTypes.default.arrayOf({
    label: _propTypes.default.string,
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      key: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
      label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
      disabled: _propTypes.default.bool
    }))
  })
};
var _default = SelectInput;
exports.default = _default;